import type { BestFareByDate } from "@jb-dotcom/api/best-fares";
import type { RenderDate } from "@jetblue/kit/calendar";
import { useCallback } from "react";
import { BestFaresDateCell } from "./date-cell";

type UseBestFaresRenderDateProperties = {
  currencyCode?: string;
  faresByDate: Map<string, BestFareByDate>;
  isLoading: boolean;
  monthlyMinsByDate: Map<string, number>;
  usePoints: boolean;
};

export const useBestFaresRenderDate = ({
  currencyCode,
  faresByDate,
  isLoading,
  monthlyMinsByDate,
  usePoints,
}: UseBestFaresRenderDateProperties) =>
  useCallback<RenderDate>(
    ({ date, isActive, isDisabled }) => {
      if (!date) {
        return null;
      }

      const dateKey = date.toString();
      const fare = faresByDate.get(dateKey);
      const monthMinimum = monthlyMinsByDate.get(dateKey.slice(0, 7));

      return (
        <BestFaresDateCell
          currencyCode={currencyCode}
          date={date}
          fare={fare}
          isActive={isActive}
          isDisabled={isDisabled}
          isLoading={isLoading}
          isLowestFare={fare ? monthMinimum === fare.amount : false}
          usePoints={usePoints}
        />
      );
    },
    [currencyCode, faresByDate, isLoading, monthlyMinsByDate, usePoints],
  );
